export enum FreezerTypesEnum{
   
    IQF1 ='IQF1',
    IQF2='IQF2',
    IQF3='IQF3',
    PF ='PF'
}